function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon } from '@signicat/designi/components/icons';
import PageHeader from "../components/common/PageHeader";
import ConfirmModal from "../components/common/ConfirmModal";
import DragAndDrop from "../components/common/DragAndDrop";
import LoadingOverlay from "../components/common/LoadingOverlay";
import { createContacts, downloadTemplate } from "../store/actions/contacts";
import { contacts as contactsService } from "../services";
import ImportedContacts from "../components/import/ImportedContacts";
import t from "../scripts/i18n";
import "../styling/pages/Import.css";

var Import = function Import(props) {
  var history = useHistory();
  var dispatch = useDispatch();
  var dropRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      parsedContacts = _useState4[0],
      setParsedContacts = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDiscardWarning = _useState6[0],
      setShowDiscardWarning = _useState6[1];

  var acceptFileTypes = '.csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

  var downloadImportTemplate = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var file, dataURI, a;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(downloadTemplate());

            case 2:
              file = _context.sent;
              dataURI = 'data:' + file.filetype + ';base64,' + file.fileContents.toString('base64');
              a = document.createElement('a');
              a.href = dataURI;
              a['download'] = file.fileDownloadName;
              a.click();
              a.remove();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadImportTemplate() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleDrop = function handleDrop(file) {
    if (acceptFileTypes.split(', ').includes(file.type)) parseImportedContacts(file);else console.error("The type of file \"".concat(file.name, "\" is not supported"));
  };

  var parseImportedContacts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
      var formData, contacts;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (file) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              setLoading(true);
              formData = new FormData();
              formData.append('File', file);
              formData.append('validation', true);
              _context2.prev = 6;
              _context2.next = 9;
              return contactsService.importContacts(formData);

            case 9:
              contacts = _context2.sent;

              if (contacts.length) {
                contacts = contacts.sort(function (a, b) {
                  return a.contact.firstName.localeCompare(b.contact.firstName);
                });
                setParsedContacts(contacts);
              } else dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });

              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](6);
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });
              console.error(_context2.t0);

            case 17:
              _context2.prev = 17;
              setLoading(false);
              return _context2.finish(17);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 13, 17, 20]]);
    }));

    return function parseImportedContacts(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var importFile = function importFile() {
    var input = document.createElement('input');
    input.classList.add('display-none');
    input.type = 'file';
    input.multiple = false;
    input.accept = acceptFileTypes;

    input.onchange = function (e) {
      if (!e.target.files || e.target.files.length <= 0) return;
      parseImportedContacts(e.target.files[0]);
    };

    input.click();
  };

  var saveContacts = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(contacts) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return dispatch(createContacts(contacts));

            case 4:
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_contacts_import_success'),
                  type: 'success'
                }
              });
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0);
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });

            case 11:
              _context3.prev = 11;
              setLoading(false);
              history.push('/contacts');
              return _context3.finish(11);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7, 11, 15]]);
    }));

    return function saveContacts(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: "page-container import-container"
  }, /*#__PURE__*/React.createElement(DragAndDrop, {
    handleFileDrop: handleDrop
  }), /*#__PURE__*/React.createElement(PageHeader, {
    title: t('import_page_header')
  }), !parsedContacts.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "template-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "template-instructions"
  }, /*#__PURE__*/React.createElement("p", null, t('import_template_helptext', {
    maxContacts: 100
  }))), /*#__PURE__*/React.createElement("button", {
    className: "download-template",
    onClick: downloadImportTemplate
  }, t('import_download_template'))), /*#__PURE__*/React.createElement("div", {
    className: "import"
  }, loading && /*#__PURE__*/React.createElement(LoadingOverlay, {
    background: 'gray'
  }), /*#__PURE__*/React.createElement(Icon, {
    size: "xxl",
    name: "cloudUpload"
  }), /*#__PURE__*/React.createElement("h3", null, t('import_drag_drop')), /*#__PURE__*/React.createElement("p", null, t('import_or')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: importFile
  }, t('import_browse_files')), /*#__PURE__*/React.createElement("h4", null, t('import_only_upload')))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImportedContacts, {
    contacts: parsedContacts,
    onCancel: function onCancel() {
      return setShowDiscardWarning(true);
    },
    onSuccess: saveContacts
  }), showDiscardWarning && /*#__PURE__*/React.createElement(ConfirmModal, {
    title: t('action_discard_warning'),
    question: t('action_discard_message'),
    onConfirm: function onConfirm() {
      setParsedContacts([]);
      setShowDiscardWarning(false);
    },
    onCancel: function onCancel() {
      return setShowDiscardWarning(false);
    }
  })));
};

export default Import;